export default __webpack_public_path__ + "static/media/Blue-website.c406b9d6.svg";